import PropTypes from "prop-types"
import { useDispatch } from "react-redux"
import { clearActiveUser } from "@/redux/features/activeUserSlice"
import * as styles from "@/styles/modules/UserRecognizer.module.scss"

const UserRecognizer = ({ className, identifier }) => {
  const dispatch = useDispatch()

  function handleClearUser() {
    dispatch(clearActiveUser())
  }
  return (
    <div className={[styles.wrapper, className ? className : null].join(" ")}>
      <p>{identifier}</p>
      <button className={styles.notYouBtn} onClick={handleClearUser}>
        not you?
      </button>
    </div>
  )
}

UserRecognizer.propTypes = {
  identifier: PropTypes.string.isRequired,
}

export default UserRecognizer
